import { prop } from 'ramda';
import { withRGPortlet } from 'js/components/hocs/withRGPortlet';
import { componentService } from 'js/services/component.service';

import { fetchLimits } from '../server';
import { LimitsForm } from './LimitsForm';
import parse, { parseConfig } from './parse';
import reducer, { initialValue } from './reducer';
import { RESPONSIBLE_GAMING_BET_LIMITS, RESPONSIBLE_GAMING_LOSS_LIMITS } from './constants';

const ENABLE_PROPS = {
    responsiblegamingbetlimits: 'betLimitEnabled',
    responsiblegaminglosslimits: 'lossLimitEnabled'
};

export const isLimitEnabled = (config, type) => {
    const propName = ENABLE_PROPS[type];

    if (!propName) {
        throw new Error('Unknown limits type');
    }

    return prop(propName, config);
};

export const BetLossLimits = withRGPortlet({
    forLoggedIn: true,
    reducer,
    initialValue,
    onResponse: parse,
    fetch: fetchLimits,

    // limits specific options
    parseConfig,
    isLimitEnabled
})(LimitsForm);

componentService.registerPageComponents({
    [RESPONSIBLE_GAMING_BET_LIMITS]: BetLossLimits,
    [RESPONSIBLE_GAMING_LOSS_LIMITS]: BetLossLimits
});
